import { InjectionToken } from '@angular/core';

export const X_SERVICE_ZONE = new InjectionToken<string>('X_SERVICE_ZONE');
export const SSR_BODY_CLASS = new InjectionToken<string>('SSR_BODY_CLASS');
